import React from "react";
import "../deviceProfile.css";
import ReviewProfileDetails from "./shared/review/profileDetails";
import ReviewAttributes from "./shared/review/attributes";
import ReviewLocations from "./shared/review/locations";
import ReviewFrequency from "./shared/review/frequency";
import { Switch } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateUI } from "../../../store/actions/deviceProfile";

function CreateDeviceProfileStepReview() {
  const dispatch = useDispatch();
  const {
    hasAttributes,
    hasLocations,
    formFields,
    type,
    name,
    autoResolveForAllAlert,
    selectedDeviceType,
  } = useSelector((state) => {
    let hasLocations = false;
    let hasAttributes = false;

    if (
      Array.isArray(state.deviceProfile.ui.form.fields.step3.locations) &&
      state.deviceProfile.ui.form.fields.step3.locations.length > 1
    ) {
      hasLocations = true;
    } else if (
      Array.isArray(state.deviceProfile.ui.form.fields.step3.locations) &&
      state.deviceProfile.ui.form.fields.step3.locations.length === 1
    ) {
      hasLocations = Object.values(
        state.deviceProfile.ui.form.fields.step3.locations[0]
      )
        .map((loc) => loc.value)
        .some((loc) => loc !== "");
    }

    if (
      state.deviceProfile.ui.form.fields.step4.monitorFrequency.value ||
      state.deviceProfile.ui.form.fields.step4.reportingFrequency.value
    ) {
      hasAttributes = true;
    }

    let selectedDeviceType = [];

    if (Array.isArray(state.deviceProfile.ui.form.deviceTypes)) {
      selectedDeviceType = state.deviceProfile.ui.form.deviceTypes.filter(
        (deviceType) =>
          deviceType.value ===
          state.deviceProfile.ui.form.fields.step1.deviceType.value
      );
    }

    return {
      hasAttributes,
      hasLocations,
      formFields: state.deviceProfile.ui.form.fields,
      type: state.deviceProfile.ui.form.type,
      name: state.deviceProfile.ui.form.single.name,
      autoResolveForAllAlert:
        state.deviceProfile.ui.form.fields.step2.autoResolveForAllAlert,
      selectedDeviceType,
    };
  });

  const handleAutoResolve = (change) => {
    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step2: {
              ...formFields.step2,
              autoResolveForAllAlert: change,
            },
          },
        },
      })
    );
  };

  return (
    <React.Fragment>
      <div
        className="font-face-vzw"
        style={{
          fontWeight: 700,
          fontSize: "30px",
        }}
      >
        {type === "view" ? `${name} Profile` : "Review device profile"}
      </div>
      <div className="device-profile-create-modal-container py-2">
        <ReviewProfileDetails />
        <hr />
        {/* <ReviewAttributes /> */}
        {Array.isArray(selectedDeviceType) &&
          selectedDeviceType.length > 0 &&
          (selectedDeviceType[0].devicemodel === "GAT" &&
          formFields?.step1?.profileType?.value === "nonshipment"
            ? "" 
            : (
                <>
                  <ReviewAttributes />
                  <hr />
                    <div
          className="d-flex flex-row justify-content-start align-items-center"
          style={{
            padding: "8px 0px",
            margin: "24px 0px",
          }}
        >
          <div
            className="font-face-vzw"
            style={{
              fontWeight: 700,
              fontSize: "16px",
            }}
          >
            Enable Auto-Resolve for all alerts
          </div>
          <div className="px-2">
            <Switch
              style={
                autoResolveForAllAlert
                  ? {
                      backgroundColor: "#008331",
                    }
                  : {
                      backgroundColor: "#d8dada",
                    }
              }
              checked={autoResolveForAllAlert}
              disabled={true}
              onChange={handleAutoResolve}
            />
          </div>
        </div>
                </>
              )
          )}
        {Array.isArray(selectedDeviceType) && selectedDeviceType.length > 0 && (selectedDeviceType[0].devicemodel === "GAT" || formFields?.step1?.profileType?.value==="nonshipment")  && hasLocations && (
          <>
            <ReviewLocations />
            <hr />
          </>
        )}

        {Array.isArray(selectedDeviceType) && selectedDeviceType.length > 0 && selectedDeviceType[0].devicemodel === "GAT" && hasAttributes && <ReviewFrequency />}
      </div> 
    </React.Fragment>
  );
}

export default CreateDeviceProfileStepReview;
